// ES6 Modules or TypeScript
import Swal from "sweetalert2";

export default {
  scrolling: false,

  observaciones: [],

  facturaAgencia: {
    valida: false,
    documento_cargado: false,
    monto_factura_agencia: 0,
    honorarios: 0,
    iva: 0,
    monto_pago_derechos: 0,
    monto_pago_derechos_cta_116: 0,
    total_pago_derechos: 0,
    gastos_despacho: 0,
    total_desembolsos_despacho: 0
  },

  setObservaciones(observaciones) {
    this.observaciones = observaciones;
  },

  setMontosFacturaAgencia(facturaAgencia) {
    this.facturaAgencia = facturaAgencia;
    // Recalcula y actualiza el DOM
    this.calcularMontoFacturaAgenciaDocSeleccionados();
  },

  handleFormValidation() {
    const oForm = $("#form-di");

    const aRules = {
      despacho: {
        required: true
      },
      numero_resolucion_aduana_devolucion_derechos: {
        required: function (element) {
          return (
            $(
              "select[name='estado_respuesta_aduana_devolucion_derechos']"
            ).val() !== "PENDIENTE"
          );
        }
      },
      fecha_entrega_devolucion_derechos: {
        required: function (element) {
          return (
            $("select[name='estado_pago_devolucion_derechos']").val() ===
            "APROBADO"
          );
        }
      },
      monto_devolucion_derechos: {
        required: function (element) {
          return (
            $("input[name='fecha_presentacion_devolucion_derechos']").val() !==
            ""
          );
        }
      },
      fecha_presentacion_devolucion_derechos: {
        required: function (element) {
          return $("input[name='monto_devolucion_derechos']").val() !== "";
        }
      },
      /*
      'contenedores[0][contenedor]': {
        'codigo-contenedor': true
      },
      'contenedores[1][contenedor]': {
        'codigo-contenedor': true
      }
      */
    }

    const aMessages = {
      nombre: {
        required: "El campo Despacho es obligatorio."
      },
    };

    // Validación del formulario
    FormHelper.validate(oForm, aRules, aMessages);
  },

  agregarFila($container, callback) {
    const $rows = $container.find(".js-rows-container");
    const $row = $rows.find(".js-row-template").clone();

    $row.removeClass("js-row-template").addClass("js-row-item");
    $rows.append($row.show());

    if (callback) {
      callback($row);
    }

    this.initIndicesFilas($container);
    this.initEliminarFila($container);

    return $row;
  },

  initAgregarFila($container, callback) {
    $(".js-add", $container).click(e => {
      e.preventDefault();
      this.agregarFila($container, callback);
    });
  },

  initEliminarFila($container) {
    $(".js-remove", $container)
      .unbind("click")
      .bind("click", e => {
        e.preventDefault();
        $(e.currentTarget)
          .closest(".js-row-item")
          .remove();
        this.initIndicesFilas($container);
      });
  },

  initFilasDinamicas($container, callback) {
    this.initAgregarFila($container, callback);
    this.initEliminarFila($container);
  },

  initIndicesFilas($container) {
    $(".js-row-item", $container).each(function (index) {
      $(this)
        .find("input, textarea, select")
        .each(function (i, element) {
          let name = $(element).attr("name");
          // Busca inputs del tipo nombre[index][key]
          const match = name.match(/(.*)\[(\d+)\](.*)/i);
          if (match !== null && match.length === 4) {
            //let index = parseInt(match[2]);
            name = `${match[1]}[${index + 1}]${match[3]}`;
          }
          $(element).attr("name", name);
        });
    });
  },

  initCombos() {
    $(".select2:not(.readonly)").select2({
      placeholder: "Seleccionar..."
      //allowClear: true
    });
  },

  initDoubleScroll() {
    const tableWidth = $(".table-scrollable > .table").width();
    const $topScroll = $(".top-scroll");
    $topScroll.width(tableWidth);

    const $tableWrapper = $(".table-scrollable");
    const $topScrollWrapper = $(".top-scroll-wrapper");

    $topScrollWrapper.scroll(() => {
      if (this.scrolling) {
        this.scrolling = !this.scrolling;
        return true;
      }
      this.scrolling = true;
      $tableWrapper.scrollLeft($topScrollWrapper.scrollLeft());
    });

    $tableWrapper.scroll(() => {
      if (this.scrolling) {
        this.scrolling = !this.scrolling;
        return true;
      }
      this.scrolling = true;
      $topScrollWrapper.scrollLeft($tableWrapper.scrollLeft());
    });
  },

  initVerMas() {
    $(".js-ver-mas").click(function () {
      let $icono = $(this).find(".js-icono");
      let $texto = $(this).find(".js-texto");
      let $datos = $(this).prev(".js-ver-mas-datos");

      if ($datos.hasClass("hidden")) {
        $datos.removeClass("hidden");
        $icono.removeClass("fa-plus").addClass("fa-minus");
        $texto.html("Ver menos");
      } else {
        $datos.addClass("hidden");
        $icono.removeClass("fa-minus").addClass("fa-plus");
        $texto.html("Ver más");
      }
    });
  },

  initDatePickers() {
    $(".js-datepicker:not([readonly])").datepicker({
      orientation: "left",
      autoclose: true,
      format: "dd/mm/yyyy",
      language: "es"
    });
  },

  initNumbers() {
    $(".js-number:not(.decimal)").number(true, 0, ",", ".");
    $(".js-number.decimal").number(true, 2, ",", ".");
  },

  initSeccionDinamica($container, data, callback) {
    this.initFilasDinamicas($container, callback);

    if (data.length === 0) {
      // Agrega una fila vacía e inicializa sus eventos
      $(".js-add", $container).trigger("click");
    } else {
      // Por cada item, agrega la fila, popula los datos e inicializa los eventos
      data.forEach(item => {
        const $row = this.agregarFila($container);
        if (callback) {
          callback($row, item);
        }
      });
    }
  },

  initSeccionObservaciones() {
    this.initSeccionDinamica(
      $(".js-observaciones"),
      this.observaciones,
      ($row, item) => {
        if (item) {
          // Agrega los datos de la observación
          $row.find("textarea").val(item.observacion);
          $row.find('input[name*="id"]').val(item.id);
          $row.find('input[name*="fecha"]').val(item.fecha);
        }
      }
    );
  },

  initReferenciasTags() {
    $('input[name="referencias"]').tagsinput({
      trimValue: true,
      tagClass: "label taginput-grey"
    });
  },

  initReadOnlySelects() {
    const $selects = $("select.readonly");
    $selects.find("option:not(:selected)").prop("disabled", true);
    $selects
      .next("span.select2.select2-container")
      .addClass("select2-container--disabled");
  },

  initMostrarModalCargaDocumentos() {
    $(".js-mostrar-modal-carga-documentos").click(function () {
      const url = $(this).data("url");
      const $docsContainer = $(".js-modal-documentos-cargados");
      const estado = $(this).data("estado");

      // Tab a mostrar luego de la carga
      $('input[name="mostrar_tab"]').val($(this).data("tab"));

      if (url) {
        $docsContainer.removeClass("hidden");
        $(".js-documento", $docsContainer)
          .attr("href", url)
          .html($(this).data("nombre"));

        // Por defecto muestra todos los botones
        $(".js-aprobar-documento", $docsContainer).removeClass("hidden");
        $(".js-rechazar-documento", $docsContainer).removeClass("hidden");
        $(".js-eliminar-documento", $docsContainer).removeClass("hidden");

        // Esconde el botón para aprobar si ya fue aprobado
        if (estado === "APROBADO") {
          $(".js-aprobar-documento", $docsContainer).addClass("hidden");
          $(".js-rechazar-documento", $docsContainer).removeClass("hidden");
        }

        // Esconde el botón para rechazar si ya fue rechazado
        if (estado === "RECHAZADO") {
          $(".js-rechazar-documento", $docsContainer).addClass("hidden");
          $(".js-aprobar-documento", $docsContainer).removeClass("hidden");
        }
      } else {
        $docsContainer.addClass("hidden");
        $(".js-documento", $docsContainer)
          .attr("href", "#")
          .html("N/A");
      }

      $(".js-estado", $docsContainer).html($(this).data("title")); // Se usa para el tooltip

      // Elimina estados previos
      $(".js-estado", $docsContainer).removeClass(
        "label-aprobado label-rechazado"
      );

      // Agrega estado actual
      $(".js-estado", $docsContainer).addClass(
        "label-" + ($(this).data("estado") + "").toLowerCase()
      );

      $(".js-fecha", $docsContainer).html($(this).data("fecha"));
      $(".js-user", $docsContainer).html($(this).data("user"));

      const targetModal = $(this).data("target");
      $(targetModal).modal("show");
    });

    $(".js-btn-cargar-documento").click(() => {
      $(".js-form-despacho").submit();
    });
  },

  initModalCargaMasivaDocumentos() {
    $(".js-btn-carga-masiva-documentos").click(() => {
      const $form = $(".js-form-despacho");
      $form.append($('<input type="hidden" name="es_carga_masiva_documentos" value="1" />'));
      $form.submit();
    });
  },

  initModalCargasFacturasProveedor() {
    $(".js-btn-cargar-facturas-proveedor").click(() => {
      $(".js-form-despacho").submit();
    });
  },

  initOnTabChange() {
    $(".js-form-tabs a").click(function (e) {
      e.preventDefault();

      $('input[name="mostrar_tab"]').val($(this).attr("href"));

      // Actualiza el hash  en la url sin hacer scroll
      history.replaceState({}, "", window.location.pathname + $(this).attr("href"));
    });

    // Actualiza el hash de la URL al momento de cargar la ficha
    const serverHash = $('input[name="mostrar_tab"]').val();
    const browserHash = window.location.hash;

    if (!browserHash && serverHash) {
      history.replaceState({}, "", window.location.pathname + serverHash);
      $(`#js-form-tabs a[href="#${serverHash}"]`).tab('show');
    }
  },

  initAprobarRechazarDocumento() {
    $(".js-aprobar-documento, .js-rechazar-documento, .js-eliminar-documento").click(function (e) {
      e.preventDefault();

      let accion = "aprobar";

      if ($(this).hasClass("js-rechazar-documento")) {
        accion = "rechazar";
      }

      if ($(this).hasClass("js-eliminar-documento")) {
        accion = "eliminar";
      }

      const despacho = $('input[name="despacho"]').val();
      const documento = $(this).data("archivo");
      const tipoDespacho = $('input[name="tipo_despacho"]').val();
      const url = `despacho/${despacho}/documento/${documento}/${accion}`;

      let usarDocFactComercial = {};
      const $chksUsarDocFactComercial = $(
        'input[name*="usar_documento_factura_comercial["]:checked'
      );
      $chksUsarDocFactComercial.each((index, el) => {
        const name = el.name
          .replace("usar_documento_factura_comercial[", "")
          .replace("]", "");
        usarDocFactComercial[`${name}`] = 1;
      });

      Notificaciones.showBootbox("confirm", {
        mensaje: `¿Realmente desea ${accion.toUpperCase()} el documento?`,
        callback(result) {
          if (result) {
            $.ajax(url, {
              method: "POST",
              data: {
                _method: "PATCH",
                tipo_despacho: tipoDespacho,
                usar_documento_factura_comercial: usarDocFactComercial
              },
              success: response => {
                if (response.success) {
                  const tab = $(".js-form-tabs li.active a").attr("href");
                  window.location.href =
                    window.location.origin + window.location.pathname + tab;
                  window.location.reload();
                } else {
                  Notificaciones.showToastr(
                    "Ups!",
                    "No pudimos completar la acción deseada. Nuestro equipo ha sido notificado.",
                    "error"
                  );

                  throw new Error(
                    `Error al ${accion} documento '${documento}' del despacho ${despacho} (${tipoDespacho}): ${response.message}`
                  );
                }
              },
              error: err => {
                Notificaciones.showToastr(
                  "Ups!",
                  "No pudimos completar la acción deseada. Nuestro equipo ha sido notificado.",
                  "error"
                );

                throw new Error(
                  `Error al ${accion} documento '${documento}' del despacho ${despacho} (${tipoDespacho}): ${err.responseText}`
                );
              }
            });
          }
        }
      });
    });
  },

  initConfiguracionDocumentosBase() {
    $(".js-configurar-documentos-base").click(function (e) {
      e.preventDefault();

      $(".js-form-despacho").submit();
    });
  },

  toggleDateInput(input, enabled) {
    let $input = input;

    if (typeof input === "string") {
      $input = $('input[name="' + input + '"]');
    }

    if (enabled) {
      $input.datepicker({
        orientation: "left",
        autoclose: true,
        format: "dd/mm/yyyy",
        language: "es"
      });

      $input.prop("readonly", false);
      $input.removeClass("readonly");
    } else {
      $input.prop("readonly", true).val("");
      $input.addClass("readonly");
      $input.datepicker("destroy");
    }
  },

  initToggleDates() {
    const $toggleDates = $(".js-toggle-date");
    const self = this;

    // Habilita/Deshabilita las fechas de los checkbox
    $toggleDates.on("ifToggled", function (event) {
      const inputName = $(this).data("target");
      const isInverse = $(this).hasClass("js-toggle-inverse");
      const checked = isInverse ? !event.target.checked : event.target.checked;
      self.toggleDateInput(inputName, checked);
    });

    // Deshabilita las fechas de los checkbox desmarcados
    $toggleDates.each(function (i, chk) {
      const inputName = $(chk).data("target");
      const isInverse = $(this).hasClass("js-toggle-inverse");
      const checked = isInverse ? !chk.checked : chk.checked;
      self.toggleDateInput(inputName, checked);
    });
  },

  initToggleAforo() {
    const self = this;

    $(".js-toggle-aforo")
      .on("change", function (event) {
        const inputFechaName = $(this).data("target");
        const aforo = $(event.target).val();
        const enabled = aforo === "F" || aforo === "D" || aforo === 'M' || aforo === 'E' || aforo === 'S';

        self.toggleDateInput(inputFechaName, enabled);

        const inputHoraName = $(this).data("hora");
        const $inputHora = $('input[name="' + inputHoraName + '"]');
        if (enabled) {
          $inputHora.prop("readonly", false);
        } else {
          $inputHora.prop("readonly", true).val("");
        }
      })
      .trigger("change");
  },

  initToggleInspeccion() {
    const self = this;

    $(".js-toggle-inspeccion")
      .on("change", function (event) {
        const inputName = $(this).data("target");
        const inspeccion = $(event.target).val();
        const enabled = parseInt(inspeccion) === 1;

        self.toggleDateInput(inputName, enabled);
      })
      .trigger("change");
  },

  initCheckUsarDocFacturaComercial() {
    $(".js-usar-doc-factura-comercial").on("ifToggled", e => {
      this.toggleUsarDocFacturaComercial(e.target);
    });
  },

  initUsarDocFacturaComercial() {
    $(".js-usar-doc-factura-comercial").each((index, el) => {
      this.toggleUsarDocFacturaComercial(el);
    });
  },

  toggleUsarDocFacturaComercial(checbox) {
    let $checkbox = $(checbox);
    const $parentContainer = $checkbox.parents(".js-cargar-usar-documento");
    const $icon = $("i.estado-documento", $parentContainer);

    if (checbox.checked) {
      $icon.addClass("hidden");
    } else {
      $icon.removeClass("hidden");
    }
  },

  calcularMontoFacturaAgenciaDocSeleccionados() {
    // Total de egresos seleccionados
    let totalEgresos = 0;
    let $chkEgresosSeleccionados = $(
      'input[name*="incluir_documentos_fa[egresos_"]:checked'
    );
    $chkEgresosSeleccionados.each(
      (i, el) => (totalEgresos += Number($(el).data("total")))
    );

    // Pago de derechos seleccionado?
    let totalPagoDerechos = 0;
    const $chkPagoDerechos = $(
      'input[name*="incluir_documentos_fa[pago_tesoreria]"]'
    );
    if ($chkPagoDerechos.is(":checked")) {
      totalPagoDerechos = Number($chkPagoDerechos.data("total"));
    }

    const tipoDespacho = $('input[name="tipo_despacho"]').val();

    // Calcula el monto de la factura en base a los datos del SIGAD y los montos de los docs. seleccionados
    const montoFacturaAgencia =
      Math.round(
        (this.facturaAgencia.honorarios + this.facturaAgencia.gastos_despacho) *
        (tipoDespacho === 'DI' ? 1.19 : 1)
      ) +
      totalPagoDerechos +
      totalEgresos;

    const numberFormat = new Intl.NumberFormat("de-DE", {
      style: "decimal",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });

    const $elMontoFactura = $(
      ".js-valor-documentos-fa > .js-monto-factura-agencia"
    );
    const $elIva = $(".js-valor-documentos-fa > .js-iva");
    const $elDerechosAdValorem = $(
      ".js-valor-documentos-fa > .js-monto-pago-derechos"
    );
    const $elRecargoMercanciaUsada = $(
      ".js-valor-documentos-fa > .js-monto-pago-derechos-cta-116"
    );
    const $elPagoDerechos = $(
      ".js-valor-documentos-fa > .js-total-pago-derechos"
    );
    const $elDesembolsos = $(
      ".js-valor-documentos-fa > .js-total-desembolsos-despacho"
    );

    // Por defecto todos en verde
    $elMontoFactura
      .removeClass("font-red-haze")
      .addClass("font-green-coradines");
    $elPagoDerechos
      .removeClass("font-red-haze")
      .addClass("font-green-coradines");
    $elDesembolsos
      .removeClass("font-red-haze")
      .addClass("font-green-coradines");

    $elIva.removeClass("font-red-haze").addClass("font-green-coradines");
    $elDerechosAdValorem
      .removeClass("font-red-haze")
      .addClass("font-green-coradines");
    $elRecargoMercanciaUsada
      .removeClass("font-red-haze")
      .addClass("font-green-coradines");

    // Actualiza los montos
    $elMontoFactura.html("$" + numberFormat.format(montoFacturaAgencia));
    $elPagoDerechos.html("$" + numberFormat.format(totalPagoDerechos));
    $elDesembolsos.html("$" + numberFormat.format(totalEgresos));

    $elIva.html("$0");
    $elDerechosAdValorem.html("$0");
    $elRecargoMercanciaUsada.html("$0");

    if ($chkPagoDerechos.is(":checked")) {
      $elIva.html("$" + numberFormat.format(this.facturaAgencia.iva));
      $elDerechosAdValorem.html(
        "$" + numberFormat.format(this.facturaAgencia.monto_pago_derechos)
      );
      $elRecargoMercanciaUsada.html(
        "$" +
        numberFormat.format(this.facturaAgencia.monto_pago_derechos_cta_116)
      );
    } else {
      if (this.facturaAgencia.iva !== 0) {
        $elIva.addClass("font-red-haze").removeClass("font-green-coradines");
      }

      if (this.facturaAgencia.monto_pago_derechos !== 0) {
        $elDerechosAdValorem
          .addClass("font-red-haze")
          .removeClass("font-green-coradines");
      }

      if (this.facturaAgencia.monto_pago_derechos_cta_116 !== 0) {
        $elRecargoMercanciaUsada
          .addClass("font-red-haze")
          .removeClass("font-green-coradines");
      }
    }

    // Verifica que los montos cuadren con SIGAD
    if (totalPagoDerechos !== this.facturaAgencia.total_pago_derechos) {
      $elPagoDerechos
        .addClass("font-red-haze")
        .removeClass("font-green-coradines");
    }

    // Verifica que los montos cuadren con SIGAD
    if (totalEgresos !== this.facturaAgencia.total_desembolsos_despacho) {
      $elDesembolsos
        .addClass("font-red-haze")
        .removeClass("font-green-coradines");
    }

    this.facturaAgencia.valida = true;

    // Verifica que los montos cuadren con SIGAD
    if (
      montoFacturaAgencia !== this.facturaAgencia.monto_factura_agencia ||
      !this.facturaAgencia.documento_cargado
    ) {
      $elMontoFactura
        .addClass("font-red-haze")
        .removeClass("font-green-coradines");

      // Verifica que la factura está cargada
      if (!this.facturaAgencia.documento_cargado) {
        let html = $elMontoFactura.html();
        html += '<span class="block small ml-4">(Sin documento cargado)</span>';
        $elMontoFactura.html(html);
      }

      this.facturaAgencia.valida = false;
    }
  },

  initChecksDocumentosFacturacionAgencia() {
    $(".js-incluir-documentos-fa").on("ifToggled", e => {
      this.calcularMontoFacturaAgenciaDocSeleccionados();
    });
  },

  enviarMailFacturacion() {
    const despacho = $('input[name="despacho"]').val();
    const tipoDespacho = $('input[name="tipo_despacho"]').val();
    const url = `despacho/${despacho}/facturacion_agencia`;

    let incluirDocumentos = [];
    $('input[name*="incluir_documentos_fa"]:checked').each((i, el) => {
      const name = el.name
        .replace("incluir_documentos_fa[", "")
        .replace("]", "");
      incluirDocumentos.push(name);
    });

    $.ajax(url, {
      method: "POST",
      data: {
        _method: "PATCH",
        tipo_despacho: tipoDespacho,
        incluir_documentos: incluirDocumentos
      },
      success: response => {
        if (response.success) {
          Notificaciones.showToastr(
            "Facturación Agencia",
            "El mail de facturación ha sido enviado con éxito.",
            "success"
          );
        } else {
          Notificaciones.showToastr(
            "Ups!",
            "No pudimos completar la acción deseada. Nuestro equipo ha sido notificado.",
            "error"
          );

          throw new Error(
            `Error al enviar Mail Facturación Agencia del despacho ${despacho}: ${response.message}`
          );
        }

        $("#facturacionAgencia").modal("hide");
      },
      error: err => {
        Notificaciones.showToastr(
          "Ups!",
          "No pudimos completar la acción deseada. Nuestro equipo ha sido notificado.",
          "error"
        );

        $("#facturacionAgencia").modal("hide");

        throw new Error(
          `Error al enviar Mail Facturación Agencia del despacho ${despacho}: ${err.responseText}`
        );
      }
    });
  },

  enviarMailVisacion() {
    const despacho = $('input[name="despacho"]').val();
    const tipoDespacho = $('input[name="tipo_despacho"]').val();
    const url = `despacho/${despacho}/visacion`;

    $.ajax(url, {
      method: "POST",
      data: {
        _method: "PATCH",
        tipo_despacho: tipoDespacho
      },
      success: response => {
        if (response.success) {
          Notificaciones.showToastr(
            "Visación Despacho",
            "Documento generado con éxito.",
            "success"
          );
        } else {
          Notificaciones.showToastr(
            "Visación Despacho",
            `El documento de Visación no pudo ser generado.<br/><br/>${response.message}`,
            "error"
          );
        }
      },
      error: err => {
        Notificaciones.showToastr(
          "Visación Despacho",
          `El documento de Visación no pudo ser generado.<br/><br/>${err.responseText}`,
          "error"
        );
      }
    });
  },

  descargarDocumentosBase() {
    const despacho = $('input[name="despacho"]').val();
    const tipoDespacho = $('input[name="tipo_despacho"]').val();
    const url = `despacho/${despacho}/documentos_base`;

    $.ajax(url, {
      method: "POST",
      data: {
        _method: "PATCH",
        tipo_despacho: tipoDespacho
      },
      success: response => {
        if (response.success) {
          FormHelper.createLinkAndDownload(
            response.params.ruta,
            response.params.nombre
          );

          Notificaciones.showToastr(
            "Documentos Base",
            "Documento(s) listo(s) para su descarga o visualización",
            "success"
          );
        } else {
          if (response.message) {
            Notificaciones.showToastr("Error en la descarga", response.message, "error");
          } else {
            Notificaciones.showToastr(
              "Ups!",
              "No pudimos completar la acción deseada. Nuestro equipo ha sido notificado.",
              "error"
            );
          }

          throw new Error(
            `Error al generar Documentos Base del despacho ${despacho}: ${response.message}`
          );
        }
      },
      error: err => {
        Notificaciones.showToastr(
          "Ups!",
          "No pudimos completar la acción deseada. Nuestro equipo ha sido notificado.",
          "error"
        );

        throw new Error(
          `Error al generar PDF Documentos Base para el despacho ${despacho}: ${err.responseText}`
        );
      }
    });
  },

  generarDocumentosMails(tipoDocumento, linkElement) {
    const despacho = $('input[name="despacho"]').val();
    const tipoDespacho = $('input[name="tipo_despacho"]').val();
    const url = `despacho/${despacho}/generar_documentos_mails`;

    let to = null;
    let cc = null;
    let subject;
    let message;

    if (linkElement) {
      to = $(linkElement).data("to");
      cc = $(linkElement).data("cc");
      subject = $(linkElement).data("subject");
      message = $(linkElement).data("message");
    }

    let data = {
      _method: "PATCH",
      tipo_despacho: tipoDespacho,
      tipo_documento: tipoDocumento
    };

    if (tipoDocumento === "FACTURACION_AGENCIA") {
      let incluirDocumentos = [];
      $('input[name*="incluir_documentos_fa"]:checked').each((i, el) => {
        const name = el.name
          .replace("incluir_documentos_fa[", "")
          .replace("]", "");
        incluirDocumentos.push(name);
      });

      data.incluir_documentos = incluirDocumentos;
    }

    $.ajax(url, {
      method: "POST",
      data: data,
      success: response => {
        if (response.success) {
          // Solo si se debe enviar un correo...
          if (to && subject && message) {
            if (tipoDocumento === "FACTURACION_AGENCIA") {
              message = message.replace(
                "[DEBITOS]",
                response.params.detalles_email.notas_debitos
              );

              message = message.replace(
                "[CREDITOS]",
                response.params.detalles_email.notas_creditos
              );

              message = message.replace(
                "[EGRESOS]",
                response.params.detalles_email.egresos
              );
            }

            message = message.replace(
              "[LINKS_EXTRAS]",
              response.params.detalles_email.otros_enlaces || ''
            );

            FormHelper.sendMail(
              to,
              cc,
              subject,
              message.replace("[LINK]", response.params.ruta)
            );
          }

          setTimeout(() => {
            FormHelper.createLinkAndDownload(
              response.params.ruta,
              response.params.nombre
            );

            if (response.params.descargas_extras.length > 0) {
              response.params.descargas_extras.forEach(item => {
                FormHelper.createLinkAndDownload(item.ruta, item.nombre);
              });
            }
          }, 700);

          Notificaciones.showToastr(
            "Descarga Documento",
            "Documento(s) listo(s) para su descarga o visualización",
            "success"
          );
        } else {
          Notificaciones.showToastr(
            "Ups!",
            `No pudimos generar el documento deseado. ${response.message}`,
            "error"
          );
        }
      },
      error: err => {
        Notificaciones.showToastr(
          "Ups!",
          `No pudimos generar el documento deseado. ${err.responseText}`,
          "error"
        );
      }
    });
  },

  initEnviarMailFacturacion() {
    $("#enviarMailFacturacion").click(e => {
      e.preventDefault();
      $("#facturacionAgencia").modal("show");
    });

    $(".js-enviar-mail-facturacion").click(e => {
      e.preventDefault();

      if (this.facturaAgencia.valida) {
        this.enviarMailFacturacion();
      } else {
        Swal.fire({
          title: "Facturación Agencia",
          text:
            "La validación de los montos es incorrecta. ¿Realmente desea enviar el mail de facturación?",
          icon: "info",
          showCancelButton: true,
          confirmButtonText: "Sí, Enviar",
          confirmButtonColor: "#69AE4B",
          cancelButtonText: "Cancelar",
          cancelButtonColor: "#fff"
        }).then(result => {
          if (result.value) {
            this.enviarMailFacturacion();
          }
        });
      }
    });
  },

  initEnviarMailVisacion() {
    $("#enviarMailVisacion").click(e => {
      e.preventDefault();
      Swal.fire({
        title: "Enviar Mail Visación",
        text: "¿Está seguro que desea enviar el mail de visación?",
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "Sí, Enviar",
        confirmButtonColor: "#69AE4B",
        cancelButtonText: "Cancelar",
        cancelButtonColor: "#fff"
      }).then(result => {
        if (result.value) {
          this.enviarMailVisacion();
        }
      });
    });
  },

  initDescargarDocumentosBase() {
    $("#descargarDocumentosBase").click(e => {
      this.descargarDocumentosBase();
    });
  },

  initDescargarDocumentosFacturacion() {
    $("#descargarDocumentosFacturacion").click(e => {
      this.generarDocumentosMails("FACTURACION_AGENCIA");
    });

    $("#descargarDocumentosFacturacionLite").click(e => {
      this.generarDocumentosMails("FACTURACION_AGENCIA_LITE");
    });
  },

  initDescargarDocumentosVisacion() {
    $("#descargarDocumentosVisacion").click(e => {
      this.generarDocumentosMails("VISACION");
    });
  },

  initDescargarDocumentosGarantia() {
    $("#descargarDocumentosGarantia").click(e => {
      this.generarDocumentosMails("GARANTIA");
    });
  },

  initAbrirCorreoVisacion() {
    $("#abrirCorreoVisacion").click(e => {
      this.generarDocumentosMails("VISACION", e.currentTarget);
    });
  },

  initAbrirCorreoFacturacion() {
    $("#abrirCorreoFacturacion").click(e => {
      this.generarDocumentosMails("FACTURACION_AGENCIA", e.currentTarget);
    });
  },

  initAbrirCorreoGarantia() {
    $("#abrirCorreoGarantia").click(e => {
      this.generarDocumentosMails("GARANTIA", e.currentTarget);
    });
  },

  initAbrirCorreoRemesa() {
    $("#abrirCorreoRemesa").click(e => {
      const linkElement = e.currentTarget;
      FormHelper.sendMail(
        $(linkElement).data("to"),
        $(linkElement).data("cc"),
        $(linkElement).data("subject"),
        $(linkElement).data("message")
      );
    });
  },

  initAbrirCorreoRetiro() {
    $("#abrirCorreoRetiro").click(e => {
      const linkElement = e.currentTarget;
      FormHelper.sendMail(
        $(linkElement).data("to"),
        $(linkElement).data("cc"),
        $(linkElement).data("subject"),
        $(linkElement).data("message")
      );
    });
  },

  initAbrirCorreoRetiroAlmacen() {
    $("#abrirCorreoRetiroAlmacen").click(e => {
      const linkElement = e.currentTarget;
      FormHelper.sendMail(
        $(linkElement).data("to"),
        $(linkElement).data("cc"),
        $(linkElement).data("subject"),
        $(linkElement).data("message")
      );
    });
  },

  initAbrirCorreoInternacion() {
    $("#abrirCorreoInternacion").click(e => {
      this.generarDocumentosMails("INTERNACION", e.currentTarget);
    });
  },

  initAbrirCorreoSolicitudPoliza() {
    $("#abrirCorreoSolicitudPoliza").click(e => {
      this.generarDocumentosMails("SOLICITUD_POLIZA", e.currentTarget);
    });
  },

  initAbrirCorreoSolicitudRevision() {
    $("#abrirCorreoSolicitudRevision").click(e => {
      this.generarDocumentosMails("SOLICITUD_REVISION", e.currentTarget);
    });
  },

  eliminarEgreso(idEgreso) {
    $.ajax("/api/egreso/" + idEgreso, {
      method: "POST",
      data: {
        _method: "DELETE"
      },
      success: response => {
        if (response.success) {
          $("#detalle-egreso-" + idEgreso).remove();

          Notificaciones.showToastr(
            "Eliminar Egreso",
            "El Egreso fue eliminado con éxito.",
            "success"
          );
        } else {
          Notificaciones.showToastr(
            "Ups!",
            "No pudimos completar la acción deseada. Nuestro equipo ha sido notificado.",
            "error"
          );

          const despacho = $('input[name="despacho"]').val();

          throw new Error(
            `Error al eliminar el Egreso ID ${idEgreso} del despacho ${despacho}: ${response.message}`
          );
        }
      },
      error: err => {
        Notificaciones.showToastr(
          "Ups!",
          "No pudimos completar la acción deseada. Nuestro equipo ha sido notificado.",
          "error"
        );

        throw new Error(
          `Error al eliminar el Egreso ID ${idEgreso} del despacho ${despacho}: ${err.responseText}`
        );
      }
    });
  },

  initEliminarEgresos() {
    $(".js-eliminar-egreso").click(e => {
      e.preventDefault();

      const $btn = $(e.currentTarget);
      const idEgreso = $btn.data("id");
      const numEgreso = $btn.data("comprobante");
      const numFactura = $btn.data("factura");

      Swal.fire({
        title: "Eliminar Egreso",
        text: `¿Realmente desea eliminar el Egreso Nº ${numEgreso} / Factura Nº ${numFactura}? La acción no podrá ser revertida.`,
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "Sí, Eliminar",
        confirmButtonColor: "#f36a5a",
        cancelButtonText: "Cancelar",
        cancelButtonColor: "#fff"
      }).then(result => {
        if (result.value) {
          this.eliminarEgreso(idEgreso);
        }
      });
    });
  },

  toggleAprobacionRechazoDocumentos(habilitar) {
    // Todos los iconos sin documentos deben mostrar el modal de carga y aprobación/rechazo
    const $iconosSinDocumentos = $(".js-icono-documento.sin-documento");
    $iconosSinDocumentos
      .unbind("click")
      .addClass("js-mostrar-modal-carga-documentos");
    this.initMostrarModalCargaDocumentos();

    // Documentos que pueden ser editados por el cliente
    $(".js-icono-documento.cliente-allow").each((index, el) => {
      $(el)
        .unbind("click")
        .addClass("js-mostrar-modal-carga-documentos");
      this.initMostrarModalCargaDocumentos();
    });

    // Iconos sin documentos cargados (y que no puedan ser editar por el cliente)
    const $iconosConDocumentos = $(".js-icono-documento:not(.sin-documento):not(.cliente-allow)");
    if (habilitar) {
      // Todos los iconos con documentos deben mostrar el modal de carga y aprobación/rechazo
      $iconosConDocumentos
        .unbind("click")
        .addClass("js-mostrar-modal-carga-documentos");
      this.initMostrarModalCargaDocumentos();
    } else {
      // Todos los iconos con documentos deben descargar inmediatamente el archivo,
      // sin mostrar modal de carga o aprobación/rechazo
      $iconosConDocumentos.unbind("click").bind("click", e => {
        const $icono = $(e.currentTarget);
        const url = $icono.data("url");

        $icono.removeClass("js-mostrar-modal-carga-documentos");
        if (url && url.length > 0) {
          window.open(url, "_blank");
        }
      });
    }
  },

  initCheckAprobacionRechazoDocumentos() {
    $("#chkToggleAprobacionDocs").on("ifToggled", e => {
      // Recuerda la opción del usuario por 7 días
      Cookies.set(
        "cargar_aprobar_rechazar_documentos",
        e.currentTarget.checked,
        {
          expires: 7
        }
      );

      this.toggleAprobacionRechazoDocumentos(e.currentTarget.checked);
    });

    const $inputEsCliente = $('input[name="es_cliente"]');
    if ($inputEsCliente.length > 0 && $inputEsCliente.val() === '1') {
      this.toggleAprobacionRechazoDocumentos(false);
    }
  },

  initCookieCheckBoxAprobacionRechazoDocumentos() {
    let habilitar = Cookies.get("cargar_aprobar_rechazar_documentos") || false;
    habilitar = habilitar === "true";

    if (habilitar) {
      $("#chkToggleAprobacionDocs").iCheck("check");
    } else {
      this.toggleAprobacionRechazoDocumentos(false);
    }
  },

  obtenerCamionesTransportista(idTransportista, $combo, selected) {
    $combo.empty();

    $.ajax(`/api/transportista/${idTransportista}/camiones`, {
      method: "GET",
      success: response => {
        if (response.success) {
          $combo.append("<option value=''></option>");

          response.data.forEach(camion => {
            const $option = $(
              `<option value='${camion.id}'>${camion.patente}</option>`
            );

            if (selected && camion.id === selected) {
              $option.prop("selected", true);
            }

            $combo.append($option);
          });

          if (selected) {
            $combo.trigger("change");
          }
        }
      },
      error: err => {
        Notificaciones.showToastr(
          "Ups!",
          "No pudimos obtener la acción deseada. Nuestro equipo ha sido notificado.",
          "error"
        );

        throw new Error(
          `Error al obtener los camiones del Transportista ID ${idTransportista}: ${err.responseText}`
        );
      }
    });
  },

  obtenerChoferesTransportista(idTransportista, $combo, selected) {
    $combo.empty();

    $.ajax(`/api/transportista/${idTransportista}/choferes`, {
      method: "GET",
      success: response => {
        if (response.success) {
          $combo.append("<option value=''></option>");

          response.data.forEach(chofer => {
            const $option = $(
              `<option value="${chofer.id}" data-rut="${chofer.rut}" data-telefono="${chofer.telefono}">${chofer.nombre}</option>`
            );

            if (selected && chofer.id === selected) {
              $option.prop("selected", true);
            }

            $combo.append($option);
          });

          if (selected) {
            $combo.trigger("change");
          }
        }
      },
      error: err => {
        Notificaciones.showToastr(
          "Ups!",
          "No pudimos obtener la acción deseada. Nuestro equipo ha sido notificado.",
          "error"
        );

        throw new Error(
          `Error al obtener los choferes del Transportista ID ${idTransportista}: ${err.responseText}`
        );
      }
    });
  },

  initComboTransportes() {
    $(".js-transportistas")
      .change(e => {
        const $currentCombo = $(e.currentTarget);
        const id = $currentCombo.val();
        const despacho = $currentCombo.data("despacho");
        //const choferId = $currentCombo.data("chofer-id");
        //const camionId = $currentCombo.data("camion-id");
        const contenedor = $currentCombo.data("contenedor");

        /*
        let $comboCamiones = $(
          `select[name="${$currentCombo.data("combo-camiones")}"]`
        );

        let $comboChoferes = $(
          `select[name="${$currentCombo.data("combo-choferes")}"]`
        );
        */

        let $comboAlmacenes = null;
        let $comboDevoluciones = null;
        //let $inputFecha = null;
        //let $inputHora = null;
        //let $inputKilos = null;
        //let $inputVolumen = null;

        if (contenedor) {
          /*
          $comboCamiones = $(
            `select[name="${$currentCombo.data(
              "combo-camiones"
            )}"][data-contenedor="${contenedor}"]`
          );

          $comboChoferes = $(
            `select[name="${$currentCombo.data(
              "combo-choferes"
            )}"][data-contenedor="${contenedor}"]`
          );
          */

          $comboAlmacenes = $(
            `select[name="${$currentCombo.data(
              "combo-almacenes"
            )}"][data-contenedor="${contenedor}"]`
          );

          $comboDevoluciones = $(
            `select[name="${$currentCombo.data(
              "combo-devoluciones"
            )}"][data-contenedor="${contenedor}"]`
          );

          /*
          $inputFecha = $(
            `input[name="${$currentCombo.data(
              "input-fecha"
            )}"][data-contenedor="${contenedor}"]`
          );

          $inputHora = $(
            `input[name="${$currentCombo.data(
              "input-hora"
            )}"][data-contenedor="${contenedor}"]`
          );
          */

          /*
          $inputKilos = $(
            `input[name="${$currentCombo.data(
              "input-kilos"
            )}"][data-contenedor="${contenedor}"]`
          );

          $inputVolumen = $(
            `input[name="${$currentCombo.data(
              "input-volumen"
            )}"][data-contenedor="${contenedor}"]`
          );
          */

          if (id) {
            //this.toggleDateInput($inputFecha, true);

            //$inputHora.prop("readonly", false);
            //$inputHora.removeClass("readonly");

            //$inputKilos.prop("readonly", false);
            //$inputKilos.removeClass("readonly");

            //$inputVolumen.prop("readonly", false);
            //$inputVolumen.removeClass("readonly");

            /*
            $comboCamiones.removeClass("readonly");
            if (!$comboCamiones.hasClass("init")) {
              this.initComboCamiones($comboCamiones);
            }

            $comboChoferes.removeClass("readonly");
            if (!$comboChoferes.hasClass("init")) {
              this.initComboChoferes($comboChoferes);
            }
            */

            $comboAlmacenes.removeClass("readonly");
            $comboAlmacenes.find("option").prop("disabled", false);
            $comboAlmacenes.select2({
              placeholder: "Seleccionar..."
            });

            $comboDevoluciones.removeClass("readonly");
            $comboDevoluciones.find("option").prop("disabled", false);
            $comboDevoluciones.select2({
              placeholder: "Seleccionar..."
            });
          }
        }

        if (!id) {
          return;
        }

        //this.obtenerCamionesTransportista(id, $comboCamiones, camionId);
        //this.obtenerChoferesTransportista(id, $comboChoferes, choferId);

        /*
        if (camionId) {
          $currentCombo.data("camion-id", null);
        }

        if (choferId) {
          $currentCombo.data("chofer-id", null);
        }
        */

        // Actualiza la tabla pivote di_transportes_retiro (asigna el transportee al despacho)
        if (contenedor) {
          this.actualizarPropiedadDespachoContenedor(
            despacho,
            contenedor,
            "transportista_id",
            id
          );
        } else {
          this.actualizarPropiedadDespacho(
            despacho,
            null,
            null,
            "transportesRetiro",
            id
          );
        }
      })
      .trigger("change");
  },

  initToggleSelect() {
    $(".js-toggle-select")
      .change(e => {
        const $currentCombo = $(e.currentTarget);
        const $targetCombo = $(
          `select[name="${$currentCombo.data("target")}"]`
        );

        if ($currentCombo.val()) {
          $targetCombo.removeClass("readonly");
          $targetCombo.find("option").prop("disabled", false);
          $targetCombo.select2({
            placeholder: "Seleccionar..."
          });
        }
      })
      .trigger("change");
  },

  initToggleTransporteDespachoSelect() {
    $(".js-toggle-transporte")
      .change(e => {
        const $currentCombo = $(e.currentTarget);
        const contenedor = $currentCombo.data("contenedor");

        if ($currentCombo.val()) {
          const $comboAlmacen = $(
            `select[name="contenedores[${contenedor}][almacen_portuario_id]"]`
          );
          const $comboDepositoVacio = $(
            `select[name="contenedores[${contenedor}][deposito_vacio_id]"]`
          );

          $comboAlmacen.removeClass("readonly");
          $comboAlmacen.find("option").prop("disabled", false);
          $comboAlmacen.select2({
            placeholder: "Seleccionar..."
          });

          $comboDepositoVacio.removeClass("readonly");
          $comboDepositoVacio.find("option").prop("disabled", false);
          $comboDepositoVacio.select2({
            placeholder: "Seleccionar..."
          });

          //this.toggleDateInput(`contenedores[${contenedor}][fecha]`, true);
          //this.toggleDateInput(`contenedores[${contenedor}][fecha_directo]`, true);

          /*
          $(`input[name="contenedores[${contenedor}][estado]"]`)
            .removeClass("readonly")
            .prop("readonly", false);
          $(`input[name="contenedores[${contenedor}][hora_directo]"]`)
            .removeClass("readonly")
            .prop("readonly", false);
          $(`input[name="contenedores[${contenedor}][hora]"]`)
            .removeClass("readonly")
            .prop("readonly", false);
          */

          $(`input[name="contenedores[${contenedor}][kilos]"]`)
            .removeClass("readonly")
            .prop("readonly", false);
          $(`input[name="contenedores[${contenedor}][volumen]"]`)
            .removeClass("readonly")
            .prop("readonly", false);
        }
      })
      .trigger("change");
  },

  initToggleCargaSeguroContenedor() {
    $(".js-toggle-seguro-contenedor")
      .change(e => {
        const valor = e.currentTarget.value;
        const $iconWrapper = $(".js-icono-poliza-seguro-contenedor");
        $iconWrapper.hide();

        if (valor === "COMODATO" || valor === "POLIZA_SEGURO") {
          $iconWrapper.show();
        }
      })
      .trigger("change");

    $(".js-toggle-seguro-contenedor-ops")
      .change(e => {
        const target = $(e.currentTarget).data("target");
        const valor = $(e.currentTarget).val();

        if (valor === "COMODATO" || valor === "POLIZA_SEGURO") {
          this.toggleDateInput(target, true);
        } else {
          this.toggleDateInput(target, false);
        }
      })
      .trigger("change");
  },

  initComboCamiones($combo) {
    const $selector = $combo || $(".js-camiones");

    $selector
      .addClass("init")
      .select2({
        tags: true,
        selectOnClose: true,
        createTag: function (params) {
          const $currentCombo = $(this)[0].$element;
          const contenedor = $currentCombo.data("contenedor");

          let $cmbTransportistas = $(
            `select[name="${$currentCombo.data("combo-transportistas")}"]`
          );

          if (contenedor) {
            $cmbTransportistas = $(
              `select[name="${$currentCombo.data(
                "combo-transportistas"
              )}"][data-contenedor="${contenedor}"]`
            );
          }

          const idTransportista = $cmbTransportistas.val();

          // Patentes del tipo XXYY412 o XXYY-12
          const term = params.term.replace(/[^\w\d]/, "").toUpperCase();
          const pattern = /[\w\d]{6}/g;

          if (!pattern.test(term) || !idTransportista || term.length !== 6) {
            return null;
          }

          return {
            id: "new_term",
            text: term
          };
        }
      })
      .on("select2:close", e => {
        const dataSelected =
          e.params && e.params.originalSelect2Event
            ? e.params.originalSelect2Event.data
            : null;

        // Si no hay datos seleccionados o no es un tag nuevo sale
        if (!dataSelected || dataSelected.id !== "new_term") return;

        const $currentCombo = $(e.currentTarget);
        const despacho = $currentCombo.data("despacho");
        const contenedor = $currentCombo.data("contenedor");
        const comboTarget = $currentCombo.data("combo-transportistas");

        let $cmbTransportistas = $(`select[name="${comboTarget}"]`);

        if (contenedor) {
          $cmbTransportistas = $(
            `select[name="${comboTarget}"][data-contenedor="${contenedor}"]`
          );
        }

        const idTransportista = $cmbTransportistas.val();

        // Crea el camión
        axios("/api/camion", {
          method: "post",
          data: {patente: dataSelected.text, transportista: idTransportista}
        })
          .then(response => {
            const camion = response.data || null;

            if (camion && camion.id) {
              // Reemplaza la opción seleccionada con el nuevo ID
              $currentCombo
                .find(`option[value="new_term"]`)
                .val(camion.id)
                .prop("selected", true);

              // Actualiza la tabla pivote di_transportes_retiro
              if (contenedor) {
                this.actualizarPropiedadDespachoContenedor(
                  despacho,
                  contenedor,
                  "camion_id",
                  camion.id
                );
              } else {
                this.actualizarPropiedadDespacho(
                  despacho,
                  "camion_id",
                  camion.id,
                  "transportesRetiro",
                  idTransportista
                );
              }

              // Agrega la nueva patente a todos los otros combos que tenga seleccionado el mismo transportista
              $(".js-camiones").each(function (i, combo) {
                if (combo.name !== $currentCombo.attr("name")) {
                  const $combo = $(combo);
                  const contenedor = $combo.data("contenedor");

                  let $cmbTransportistas = $(
                    `select[name="${$combo.data("combo-transportistas")}"]`
                  );

                  if (contenedor) {
                    $cmbTransportistas = $(
                      `select[name="${$combo.data(
                        "combo-transportistas"
                      )}"][data-contenedor="${contenedor}"]`
                    );
                  }

                  const transportista = $cmbTransportistas.val();

                  // Solo actualiza los combos del transportista seleccionado
                  if (transportista === idTransportista) {
                    $combo.append(
                      `<option value="${camion.id}">${camion.patente}</option>`
                    );
                  }
                }
              });
            }
          })
          .catch(err => {
            throw err;
          });
      })
      .on("change", e => {
        const $currentCombo = $(e.currentTarget);
        const despacho = $currentCombo.data("despacho");
        const camionId = $currentCombo.val();
        const contenedor = $currentCombo.data("contenedor");

        const comboTarget = $currentCombo.data("combo-transportistas");
        let $cmbTransportistas = $(`select[name="${comboTarget}"]`);

        if (contenedor) {
          $cmbTransportistas = $(
            `select[name="${comboTarget}"][data-contenedor="${contenedor}"]`
          );
        }

        const idTransportista = $cmbTransportistas.val();

        if (camionId === "new_term") {
          return;
        }

        if (contenedor) {
          this.actualizarPropiedadDespachoContenedor(
            despacho,
            contenedor,
            "camion_id",
            camionId
          );
        } else {
          this.actualizarPropiedadDespacho(
            despacho,
            "camion_id",
            camionId,
            "transportesRetiro",
            idTransportista
          );
        }
      });
  },

  initComboChoferes($combo) {
    const $selector = $combo || $(".js-choferes");

    $selector
      .addClass("init")
      .select2({
        selectOnClose: true,
        tags: true,
        createTag: function (params) {
          const $currentCombo = $(this)[0].$element;
          const contenedor = $currentCombo.data("contenedor");

          let $cmbTransportistas = $(
            `select[name="${$currentCombo.data("combo-transportistas")}"]`
          );

          if (contenedor) {
            $cmbTransportistas = $(
              `select[name="${$currentCombo.data(
                "combo-transportistas"
              )}"][data-contenedor="${contenedor}"]`
            );
          }

          const idTransportista = $cmbTransportistas.val();

          const term = params.term.toUpperCase();
          if (!idTransportista || term.length < 4) {
            return null;
          }

          return {
            id: "new_term",
            text: term
          };
        }
      })
      .on("select2:close", e => {
        const dataSelected =
          e.params && e.params.originalSelect2Event
            ? e.params.originalSelect2Event.data
            : null;

        // Si no hay datos seleccionados o no es un tag nuevo sale
        if (!dataSelected || dataSelected.id !== "new_term") return;

        const $currentCombo = $(e.currentTarget);
        const comboTarget = $currentCombo.data("combo-transportistas");
        const despacho = $currentCombo.data("despacho");
        const contenedor = $currentCombo.data("contenedor");

        let $cmbTransportistas = $(`select[name="${comboTarget}"]`);

        if (contenedor) {
          $cmbTransportistas = $(
            `select[name="${comboTarget}"][data-contenedor="${contenedor}"]`
          );
        }

        const idTransportista = $cmbTransportistas.val();

        // Crea el chofer
        axios("/api/chofer", {
          method: "post",
          data: {nombre: dataSelected.text, transportista: idTransportista}
        })
          .then(response => {
            const chofer = response.data || null;
            if (chofer && chofer.id) {
              // Reemplaza la opción seleccionada con el nuevo ID
              $currentCombo
                .find(`option[value="new_term"]`)
                .val(chofer.id)
                .prop("selected", true);

              // Actualiza la tabla pivote di_transportes_retiro
              if (contenedor) {
                this.actualizarPropiedadDespachoContenedor(
                  despacho,
                  contenedor,
                  "chofer_id",
                  chofer.id
                );
              } else {
                this.actualizarPropiedadDespacho(
                  despacho,
                  "chofer_id",
                  chofer.id,
                  "transportesRetiro",
                  idTransportista
                );
              }

              $(".js-choferes").each(function (i, combo) {
                if (combo.name !== $currentCombo.attr("name")) {
                  const $combo = $(combo);
                  const contenedor = $combo.data("contenedor");

                  let $comboTransportista = $(
                    `select[name="${$combo.data("combo-transportistas")}"]`
                  );

                  if (contenedor) {
                    $comboTransportista = $(
                      `select[name="${$combo.data(
                        "combo-transportistas"
                      )}"][data-contenedor="${contenedor}"]`
                    );
                  }

                  const transportista = $comboTransportista.val();

                  // Solo actualiza los combos del transportista seleccionado
                  if (transportista === idTransportista) {
                    $combo.append(
                      `<option value="${chofer.id}">${chofer.nombre}</option>`
                    );
                  }
                }
              });
            }
          })
          .catch(err => {
            throw err;
          });
      })
      .on("change", e => {
        const $currentCombo = $(e.currentTarget);
        const comboTarget = $currentCombo.data("combo-transportistas");
        const despacho = $currentCombo.data("despacho");
        const contenedor = $currentCombo.data("contenedor");

        let $cmbTransportistas = $(`select[name="${comboTarget}"]`);

        const rutTargetName = $currentCombo.data("rut-chofer");
        const telefonoTargetName = $currentCombo.data("telefono-chofer");
        let $rutInput = $(`input[name="${rutTargetName}"]`);
        let $telefonoInput = $(`input[name="${telefonoTargetName}"]`);

        if (contenedor) {
          $cmbTransportistas = $(
            `select[name="${comboTarget}"][data-contenedor="${contenedor}"]`
          );

          $rutInput = $(
            `input[name="${rutTargetName}"][data-contenedor="${contenedor}"]`
          );

          $telefonoInput = $(
            `input[name="${telefonoTargetName}"][data-contenedor="${contenedor}"]`
          );
        }

        const idTransportista = $cmbTransportistas.val();
        const choferId = $currentCombo.val();

        if (choferId === "new_term") {
          $rutInput.prop("readonly", false);
          $telefonoInput.prop("readonly", false);

          return;
        }

        if (!choferId) return;

        axios("/api/chofer/" + choferId, {
          method: "get"
        })
          .then(response => {
            const chofer = response.data || null;

            if (chofer && chofer.id) {
              $rutInput.val(chofer.rut);
              $telefonoInput.val(chofer.telefono);

              $rutInput.prop("readonly", false);
              $telefonoInput.prop("readonly", false);
            }

            // Actualiza la tabla pivote di_transportes_retiro
            if (contenedor) {
              this.actualizarPropiedadDespachoContenedor(
                despacho,
                contenedor,
                "chofer_id",
                chofer.id
              );
            } else {
              this.actualizarPropiedadDespacho(
                despacho,
                "chofer_id",
                chofer.id,
                "transportesRetiro",
                idTransportista
              );
            }
          })
          .catch(err => {
            throw err;
          });
      });
  },

  initRutChoferes() {
    $(".js-rut-choferes")
      .keyup(e => {
        const $currentInput = $(e.currentTarget);
        const rut = $currentInput.val().replace(/[^\d-kK]/g, "");
        $currentInput.val(rut);
      })
      .change(e => {
        const $currentInput = $(e.currentTarget);
        const rut = $currentInput.val();

        const comboTarget = $currentInput.data("combo-choferes");
        const contenedor = $currentInput.data("contenedor");

        let $cmbChoferes = $(`select[name="${comboTarget}"]`);

        if (contenedor) {
          $cmbChoferes = $(
            `select[name="${comboTarget}"][data-contenedor="${contenedor}"]`
          );
        }

        const idChofer = $cmbChoferes.val();

        $.ajax("/api/chofer/verificar_rut", {
          method: "GET",
          data: {
            rut: rut,
            exclude: idChofer
          },
          success: response => {
            if (response.exists) {
              const chofer = response.chofer;

              Swal.fire({
                html: `El RUT ingresado corresponde al Chofer <strong>${chofer.nombre}</strong> de la empresa <strong>${chofer.transportista.nombre}</strong>.`,
                icon: "warning",
                confirmButtonText: "Ok"
              }).then(() => {
                $currentInput.focus().select();
              });
            } else {
              this.actualizarPropiedadesChofer(idChofer, "rut", rut);
            }
          },
          error: err => {
            throw err;
          }
        });
      });
  },

  initTelefonosChoferes() {
    $(".js-telefono-choferes")
      .keyup(e => {
        const $currentInput = $(e.currentTarget);
        const telefono = $currentInput.val().replace(/[^\d]/g, "");
        $currentInput.val(telefono);
      })
      .change(e => {
        const $currentInput = $(e.currentTarget);
        const telefono = $currentInput.val();
        const comboTarget = $currentInput.data("combo-choferes");
        const contenedor = $currentInput.data("contenedor");

        let $cmbChoferes = $(`select[name="${comboTarget}"]`);

        if (contenedor) {
          $cmbChoferes = $(
            `select[name="${comboTarget}"][data-contenedor="${contenedor}"]`
          );
        }

        const idChofer = $cmbChoferes.val();

        this.actualizarPropiedadesChofer(idChofer, "telefono", telefono);
      });
  },

  initHora() {
    $(".js-hora").keyup(e => {
      const $currentInput = $(e.currentTarget);
      let hora = $currentInput.val();
      hora = hora.replace(/[.;]/g, ":")
        .replace(/[^\d:]/g, "");
      $currentInput.val(hora);
    });
  },

  initPropiedadesDespacho() {
    $(".js-propiedad-despacho").change(e => {
      const $element = $(e.currentTarget);

      const despacho = $element.data("despacho");
      let contenedor = $element.data("contenedor");
      let contenedorOriginal = null;

      const value = $element.val();
      const key = $element
        .attr("name")
        .replace(`despachos[${despacho}][`, "")
        .replace("]", "");

      if (['contenedor', 'transportista_id', 'deposito_portuario_id'].includes(key)) {
        const $inputContenedorOriginal = $(`input[name="despachos[${despacho}][contenedor_original]"]`);
        if ($inputContenedorOriginal.length > 0) {
          contenedorOriginal = $inputContenedorOriginal.val();
        }

        // Si no tiene contenedor en el atributo data-, verifica si se está definido en el input
        if (!contenedor || contenedor.length === 0) {
          const $inputContenedor = $(`input[name="despachos[${despacho}][contenedor]"]`);
          if ($inputContenedor.length > 0) {
            contenedor = $inputContenedor.val();
          }
        }

        // Asignamos un valor ficticio al contenedor
        if (contenedor.length === 0) {
          contenedor = 'SIN_CONTENEDOR';
        }
      }

      if (contenedor) {
        // Actualiza la propiedad del despacho / contenedor
        this.actualizarPropiedadDespachoContenedor(
          despacho,
          contenedor,
          key,
          value,
          contenedorOriginal
        );
      } else {
        // Actualiza la propiedad del despacho
        this.actualizarPropiedadDespacho(despacho, key, value);
      }
    });
  },

  actualizarPropiedadDespacho(despacho, key, value, related, relatedKey) {
    let data = {
      _method: "PATCH",
      key: key,
      value: value
    };

    if (related && relatedKey) {
      data.related = related;
      data.relatedKey = relatedKey;
    }

    $.ajax("/api/di/" + despacho, {
      method: "POST",
      data: data,
      success: response => {
        //
      },
      error: err => {
        throw err;
      }
    });
  },

  actualizarPropiedadDespachoContenedor(despacho, contenedor, key, value, contenedorOriginal) {
    let data = {
      _method: "PATCH",
      key: key,
      value: value,
      contenedor_original: contenedorOriginal
    };

    $.ajax("/api/di/" + despacho + "/" + contenedor, {
      method: "POST",
      data: data,
      success: response => {
        //
      },
      error: err => {
        throw err;
      }
    });
  },

  actualizarPropiedadesChofer(idChofer, key, value) {
    $.ajax("/api/chofer/" + idChofer, {
      method: "POST",
      data: {
        _method: "PATCH",
        key: key,
        value: value
      },
      success: response => {
        //
      },
      error: err => {
        throw err;
      }
    });
  },

  initUrlIFrame() {
    $(".btn-modal").click(e => {
      e.preventDefault();

      const evento = $(e.currentTarget);
      const iframe = $("#detalleDocumentoIFrame");
      const urlCompleta = $("#urlCompleta").val();
      const urlSeparada = urlCompleta.split("?");
      const tipo = evento.attr("data-tipo");
      const estado = evento.attr("data-estado");
      const titulo = evento.attr("data-titulo");

      iframe.attr("src", "");

      iframe.attr(
        "src",
        urlSeparada[0] +
        "/detalle_documento?tipo=" +
        tipo +
        "&estado_documento=" +
        estado +
        "&" +
        urlSeparada[1]
      );

      $("#tituloModal").text(titulo);
      $("#modalDetalleDocumento").modal("show");
    });
  },

  initDataTable() {
    const $dataTable = $(".dataTable");

    let defaultconfig = {
      fixedHeader: true,
      scrollY: 650,
      scrollX: true,
      scrollCollapse: true,
      paging: false,
      searching: false,
      ordering: false,
      info: false,
      autoHeight: false,
      language: {
        url: 'vendor/datatables/i18n/es.json'
      },
    };

    $dataTable.each((i, tabla) => {
      let config = {...defaultconfig};
      let fixedColumns = $(tabla).data("column");

      config.paging = $(tabla).data("paging") === 'true';
      config.searching = $(tabla).data("searching") === 'true';
      config.ordering = $(tabla).data("ordering") === 'true';
      config.scrollY = $(tabla).data("scroll-y") || config.scrollY;

      if (fixedColumns) {
        config.fixedColumns = {
          heightMatch: "auto",
          leftColumns: fixedColumns
        };
      }

      $(tabla).DataTable(config);
    });
  },

  initNormalizarCodigoContenedor() {
    $('.js-normalizar-codigo-contenedor').change((e) => {
      this.normalizarCodigoContenedor(e.currentTarget);
    }).keydown((e) => {
      this.normalizarCodigoContenedor(e.currentTarget);
    })
  },

  normalizarCodigoContenedor(input) {
    let value = input.value.replace(/[\s]*[^\aA-zZ\d-]/gi, '').toUpperCase();

    // Si no viene con le guión, se lo agrega
    if (value.length === 11 && value.indexOf('-') === -1) {
      value = value.substr(0, value.length - 1) + '-' + value.substr(-1, 1);
    }

    input.value = value;
  },

  init() {
    this.initCombos();
    this.initDatePickers();
    this.initNumbers();
    this.handleFormValidation();

    this.initSeccionObservaciones();
    //this.initReferenciasTags();

    this.initReadOnlySelects();
    this.initOnTabChange();

    this.initToggleAforo();
    this.initToggleInspeccion();
    this.initToggleDates();

    this.initAprobarRechazarDocumento();
    this.initConfiguracionDocumentosBase();
    this.initCheckUsarDocFacturaComercial();
    this.initUsarDocFacturaComercial();
    this.initEnviarMailFacturacion();
    this.initEnviarMailVisacion();
    this.initChecksDocumentosFacturacionAgencia();
    this.initEliminarEgresos();
    this.initCheckAprobacionRechazoDocumentos();
    this.initCookieCheckBoxAprobacionRechazoDocumentos();
    this.initModalCargaMasivaDocumentos();
    this.initModalCargasFacturasProveedor();
    this.initDescargarDocumentosBase();
    this.initDescargarDocumentosFacturacion();
    this.initDescargarDocumentosVisacion();
    this.initDescargarDocumentosGarantia();
    this.initAbrirCorreoFacturacion();
    this.initAbrirCorreoVisacion();
    this.initAbrirCorreoGarantia();
    this.initAbrirCorreoRemesa();
    this.initAbrirCorreoRetiro();
    this.initAbrirCorreoRetiroAlmacen();
    this.initAbrirCorreoInternacion();
    this.initAbrirCorreoSolicitudRevision();
    this.initAbrirCorreoSolicitudPoliza();
    this.initToggleSelect();
    this.initToggleTransporteDespachoSelect();
    this.initToggleCargaSeguroContenedor();
    this.initNormalizarCodigoContenedor();

    this.initHora();

    this.initGuardarRecepcionBodegaCliente();
  },

  initIndex() {
    this.initCombos();
    this.initDoubleScroll();
    this.initVerMas();
    this.initDatePickers();
    this.initUrlIFrame();

    FormHelper.handleSearch();
    FormHelper.handleOrderBy();
    FormHelper.handleImports();
  },

  initIndexDesconsolidados() {
    this.initCombos();
    this.initDoubleScroll();
    this.initVerMas();
    this.initDatePickers();
    this.initToggleAforo();
    this.initHora();

    this.initCamposTransportistasRetiro();

    FormHelper.handleSearch();
    FormHelper.handleOrderBy();
    FormHelper.handleImports();
  },

  initIndexContenedores() {
    this.initCombos();
    this.initReadOnlySelects();
    this.initDoubleScroll();
    this.initVerMas();
    this.initDatePickers();
    this.initToggleAforo();

    this.initToggleCargaSeguroContenedor();
    this.initCamposTransportistasContenedor();

    FormHelper.handleSearch();
    FormHelper.handleOrderBy();
    FormHelper.handleImports();
  },

  initCamposTransportistasRetiro() {
    this.initComboTransportes();
    //this.initComboCamiones();
    //this.initComboChoferes();
    //this.initRutChoferes();
    //this.initTelefonosChoferes();
    this.initPropiedadesDespacho();
    this.initHora();
  },

  initCamposTransportistasContenedor() {
    this.initComboTransportes();
    //this.initComboCamiones();
    //this.initComboChoferes();
    //this.initRutChoferes();
    //this.initTelefonosChoferes();
    this.initPropiedadesDespacho();
    this.initHora();
  },

  initGuardarRecepcionBodegaCliente() {
    $('#btn-guardar-recepcion-bodega-cliente').click((e) => {
      e.preventDefault();

      $('input[name="guardar_recepcion_cliente"]').val(1);

      $(".js-form-despacho").submit();
    });
  },

  /**
   * Elimina un registro a traves de un POST
   *
   * @param {Object} form Formulario que elimina el registro a través de la acción configurada
   * @param {String} despacho Nombre del registro a eliminar
   */
  eliminar(form, despacho) {
    let mensaje =
      "<p>¿Realmente deseas eliminar el Despacho <strong>" +
      despacho +
      "</strong>?</p><p>La acci&oacute;n no podr&aacute; ser revertida.</p>";
    FormHelper.confirm(form, mensaje);
  },
};
